import React, { FC, useEffect } from 'react';
import DangerouslySetInnerHtml from 'components/DangerouslySetInnerHtml';
import Layout from 'components/Layout';
import Container from 'components/Container';
import ContactForm from 'components/ContactForm';
import ContactInfo from 'components/ContactInfo';
import Title from 'components/Title';
import classNames from 'classnames';
import { postMessageToParent, handleIframeMessage } from 'utils/iframeUtils';
import { FormProps } from './models';
import './Form.scss';

const Form: FC<FormProps> = ({
  brand,
  market,
  translations,
  marketTranslations,
  language,
  location,
}) => {
  const { introText } = marketTranslations;
  const { pageTitle } = translations;

  useEffect(() => {
    postMessageToParent();
    window.addEventListener('message', handleIframeMessage);

    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  return (
    <Layout className={classNames('form-page', brand)} language={language} pageTitle={pageTitle}>
      <Container className="form-page__container form-page__grid-item">
        <div className="form-page__header">
          <Title className="form-page__title form-page__grid-item" text={pageTitle} />
        </div>
        <div
          className={classNames('form-page__main', {
            'form-page__main--single-column': marketTranslations.singleColumn,
          })}
        >
          {introText !== '' ? (
            <DangerouslySetInnerHtml
              className="form-page__intro-text form-page__grid-item"
              html={introText}
            />
          ) : null}
          <ContactForm
            className="form-page__form form-page__grid-item"
            {...{ brand, market, translations, marketTranslations, language, location }}
          />
          <ContactInfo
            className="form-page__contact-info form-page__grid-item"
            {...marketTranslations}
          />
        </div>
      </Container>
    </Layout>
  );
};

export default Form;
